import { isAxiosError } from 'axios';

export function resolveCommonError(err: unknown): string {
  if (isAxiosError(err) && err.code === 'ERR_NETWORK' && !err.response?.headers) {
    return 'common.errors.networkError';
  }
  if (isAxiosError(err) && err.response?.status === 429) {
    return 'common.errors.rateLimitExceeded';
  }
  return 'common.errors.unknownError';
}
